import React from "react";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
import { useTranslation } from "react-i18next";

const galleryImages = [
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_4172.jpg",
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_2190.jpg",
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_1408.jpg",
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_2260.jpg",
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_1158.jpg",
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_2124.jpg",
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_4223-1.jpg",
  "https://ctscarprotection.com/wp-content/uploads/2025/03/IMG_1889.jpg",
];

const FourthSection = () => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation("fourthPart");

  return (
    <section
      style={{
        padding: isDesktop ? "80px 60px" : "48px 20px",
        backgroundColor: "#fff",
      }}
    >
      {/* Title */}
      <h2
        style={{
          textAlign: "center",
          fontSize: isDesktop ? "28px" : "22px",
          fontWeight: 700,
          color: "var(--color-text-primary, #1C1C1C)",
          margin: "0 0 40px",
        }}
      >
        {"ผลงานของเรา"}
      </h2>

      {/* Gallery Grid */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: isDesktop
            ? "repeat(4, 1fr)"
            : "repeat(2, 1fr)",
          gap: isDesktop ? "16px" : "12px",
        }}
      >
        {galleryImages.map((src, index) => (
          <div
            key={index}
            style={{
              borderRadius: "10px",
              overflow: "hidden",
              transition: "transform 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.03)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
          >
            <img
              src={src}
              alt={`Gallery ${index + 1}`}
              style={{
                width: "100%",
                aspectRatio: "4/3",
                objectFit: "cover",
                display: "block",
                borderRadius: "10px",
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default FourthSection;
